import { useState, useEffect } from 'react';
import {
    useGetProvincesQuery,
    useLazyGetCitiesQuery,
    useLazyGetPostalCodesQuery
} from '../services/companyApi';

export interface Province {
    id: number;
    nombre: string;
}

export interface City {
    id: number;
    nombre: string;
    codigoPostal: number;
}

export interface PostalCode {
    id: number;
    codigo: string;
}

interface useRegion {
    provincesList: {data: {provincias: Province[]}} | undefined;
    citiesList: {data: {localidades: City[]}} | undefined;
    postalCodesList: PostalCode[] | undefined;
    isLoadingProvinces: boolean;
    isLoadingCities: boolean;
    isLoadingPostalCodes: boolean;
    selectedProvince: Province | null;
    selectedCity: City | null;
    selectedPostalCode: number | null;
    handleProvinceChange: (province: Province | null) => void;
    handleCityChange: (city: City | null) => void;
    handlePostalCodeChange: (postalCode: number | null) => void;
    resetRegion: () => void;
}

const useRegion = (): useRegion => {
    const { data: provincesList, isFetching: isLoadingProvinces } = useGetProvincesQuery(null);

    const [getCities, { data: citiesList, isFetching: isLoadingCities }] = useLazyGetCitiesQuery();
    const [getPostalCodes, { data: postalCodesList, isFetching: isLoadingPostalCodes }] =
        useLazyGetPostalCodesQuery();

    const [selectedProvince, setSelectedProvince] = useState<Province | null>(null);
    const [selectedCity, setSelectedCity] = useState<City | null>(null);
    const [selectedPostalCode, setSelectedPostalCode] = useState<number | null>(null);

    console.log(selectedCity)

    const handleProvinceChange = (province: Province | null) => {
        setSelectedProvince(province);
        setSelectedCity(null);
        setSelectedPostalCode(null);

        if (province?.id) {
            getCities({ provinceId: province.id });
        }
    };

    const handleCityChange = (city: City | null) => {
        setSelectedCity(city);
        handlePostalCodeChange(city?.codigoPostal || null);
    };

    const handlePostalCodeChange = (codigoPostal: number | null) => {
        setSelectedPostalCode(codigoPostal);
    };

    const resetRegion = () => {
        setSelectedProvince(null);
        setSelectedCity(null);
        setSelectedPostalCode(null);
    }

    useEffect(() => {
        if (!selectedCity?.id) return;
        if (selectedCity?.id && citiesList?.data?.localidades?.length >= 0) {
            const cityWithPostalCode = citiesList?.data?.localidades?.find((city: City) => city.id === selectedCity?.id)
            handlePostalCodeChange(cityWithPostalCode?.codigoPostal || null);
        }
    }, [citiesList, selectedCity?.id])

    return {
        provincesList,
        citiesList,
        postalCodesList,
        isLoadingProvinces,
        isLoadingCities,
        isLoadingPostalCodes,
        selectedProvince,
        selectedCity,
        selectedPostalCode,
        handleProvinceChange,
        handleCityChange,
        handlePostalCodeChange,
        resetRegion
    };
};

export default useRegion;
